(function ($, Drupal) {
  Drupal.behaviors.intiminaCCValidation = {
    attach(context, settings) {
      $('#edit-lfi-credit-card-add-payment-method-payment-details', context).once('ccvalidation', function () {
        const ccfield = $(this),
          formItem = ccfield.parent('.form-item'),
          cardType = $('#edit-lfi-credit-card-add-payment-method-payment-details-card-number');
        ccfield.validateCreditCard(function (result) {
          if (result.cardType != null && result.cardType.name != '') {
            const cardType = result.cardType.name;
            if (cardType == 'visa') {
              formItem.addClass('visa');
              cardType.val('visa');
            }
            if (cardType == 'mastercard') {
              formItem.addClass('mastercard');
              cardType.val('mastercard');
            }
            if (cardType == 'amex') {
              formItem.addClass('amex');
              cardType.val('amex');
            }
            if (cardType == 'discover') {
              formItem.addClass('discover');
              cardType.val('discover');
            }
            if (cardType == 'jcb') {
              formItem.addClass('jcb');
              cardType.val('jcb');
            }
            $(this).keyup(function (e) {
              if ($(this).val() == '') {
                formItem.removeClass('visa mastercard amex discover jcb');
              }
            });
          }
        });
      });
    },
  };
}(jQuery, Drupal));
